import React, { useState, useEffect } from "react";
// import { urls } from "../../adresses";

import moment from "moment";

import convert from "convert-seconds";

import "./matchhistory.scss";

export default function MatchHistory({
  championID,
  championsList,
  match,
  userData,
  summoners,
  queueId,
}) {
  const [gameData, setGameData] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [participantIdentities, setParticipantIdentities] = useState(
    []
  );

  // Sayfa yüklendiği gibi oyun verilerini state'e kaydeder
  useEffect(() => {
    if (match) {
      fetch(`https://apiofopgg.herokuapp.com/game/${match.gameId}`)
        .then(res => res.json())
        .then(data => {
          setGameData(data);
          // console.log(data);
        });
    }
  }, []);

  // Eğer gameData varsa stateteki oyuncuları doldurur.
  useEffect(() => {
    if (gameData) {
      setParticipantIdentities(gameData.participantIdentities);
      setParticipants(gameData.participants);
    }
  }, [gameData]);

  /* JSON dosyasından şampiyonları alır eğer girilen ID ile JSON dosyasındaki ID 
  eşitse champ ismi  döner */
  const getChampion = id => {
    if (championsList) {
      // Championlistteki her bir key girilen ID yani şampiyon numarası eşitse
      for (var i in championsList) {
        if (championsList[i].key == id) {
          return championsList[i].id;
        }
      }
    }
  };

  // Oyuncunun spellinin ismini döner
  const getSummoners = id => {
    if (summoners) {
      for (var i in summoners) {
        if (summoners[i].key == id) {
          return summoners[i].id;
        }
      }
    }
  };

  // Oyunun Türünü Almak İçin Fonksiyon
  const getMatchType = id => {
    if (queueId) {
      for (var queue of queueId) {
        if (queue.queueId === id) {
          return queue.description;
        }
      }
    }
  };

  // getMatchType(450);

  // Oyuncunun o maçtaki ID'sini dönen fonksiyon
  const getEachUserId = () => {
    let participantId;
    if (participantIdentities.length) {
      participantIdentities.forEach(participant => {
        if (participant.player.accountId === userData.accountId) {
          participantId = participant.participantId;
        }
      });
    }
    return participantId;
  };

  // getEachUserId fonksiyonundan dönen id ile her bir participantın id'sini kıyasla
  const eachParticipant = () => {
    const userId = getEachUserId();
    var userObj = null;
    if (participants.length) {
      participants.forEach(participant => {
        if (participant.participantId === userId) {
          userObj = participant;
        }
      });
    }

    return userObj;
  };
  var participantObj = eachParticipant();
  // console.log(participantObj);

  return (
    // "match_history win"
    <>
      {participantObj && (
        <div
          className={`match_history ${
            participantObj.stats.win ? "win" : "lose"
          }`}>
          <div className="match_history--1">
            <div className="topdiv">
              {gameData && (
                <h1>
                  {getMatchType(gameData.queueId).replace(
                    /games/g,
                    ""
                  )}
                </h1>
              )}
              {gameData && (
                <span>
                  {moment(
                    moment(gameData.gameCreation),
                    moment()
                  ).fromNow()}
                </span>
              )}
            </div>
            <div className="empty"></div>
            <div className="bottomdiv">
              <h1>
                {participantObj.stats.win ? "Victory" : "Defeat"}
              </h1>
              {gameData && (
                <span>
                  {convert(gameData.gameDuration).minutes}m{" "}
                  {convert(gameData.gameDuration).seconds}s
                </span>
              )}
            </div>
          </div>
          <div className="match_history--2">
            <div className="heroes">
              {championID ? (
                <div
                  style={{
                    backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/champion/${getChampion(
                      championID
                    )}.png")`,
                  }}
                  className="heroimg"></div>
              ) : (
                <div className="heroimg"></div>
              )}
              <div className="spells">
                <div
                  style={{
                    backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/spell/${getSummoners(
                      participantObj.spell1Id
                    )}.png")`,
                  }}
                  className="spell spell--1"></div>
                <div className="spell spell--2"></div>
                <div
                  style={{
                    backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/spell/${getSummoners(
                      participantObj.spell2Id
                    )}.png")`,
                  }}
                  className="spell spell--3"></div>
                <div className="spell spell--4"></div>
              </div>
            </div>
            <span>{getChampion(championID)}</span>
          </div>
          <div className="match_history--3">
            <h1>
              {participantObj.stats.kills}/
              {participantObj.stats.deaths}/
              {participantObj.stats.assists}
            </h1>
            <span className="kda">2,06:1 KDA</span>
            {participantObj.stats.doubleKills > 0 ? (
              <span className="speciality">Double Kill</span>
            ) : (
              <div></div>
            )}
          </div>
          <div className="match_history--4">
            <span>Level {participantObj.stats.champLevel}</span>
            <span className="red">P/Kill 58%</span>
            <span>{participantObj.stats.totalMinionsKilled} CS</span>
            <span>
              Elo: <span className="blue">24LP</span>
            </span>
            <span>Ward: {participantObj.stats.wardsPlaced}</span>
            <span>
              Tier: <span className="blue">Diamond 1</span>
            </span>
          </div>
          <div className="match_history--5">
            <div className="items">
              <div
                style={{
                  backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/item/${participantObj.stats.item0}.png")`,
                }}
                className="item item--1"></div>
              <div
                style={{
                  backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/item/${participantObj.stats.item1}.png")`,
                }}
                className="item item--2"></div>
              <div
                style={{
                  backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/item/${participantObj.stats.item2}.png")`,
                }}
                className="item item--3"></div>
              <div
                style={{
                  backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/item/${participantObj.stats.item3}.png")`,
                }}
                className="item item--4"></div>
              <div
                style={{
                  backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/item/${participantObj.stats.item4}.png")`,
                }}
                className="item item--5"></div>
              <div
                style={{
                  backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/item/${participantObj.stats.item5}.png")`,
                }}
                className="item item--6"></div>
              <div
                style={{
                  backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/item/${participantObj.stats.item6}.png")`,
                }}
                className="item item--7"></div>
              <div className="market"></div>
            </div>
            <div className="ward">
              <div className="ward__img"></div>
              <span className="ward__counter">
                Control Ward{" "}
                {participantObj.stats.visionWardsBoughtInGame}
              </span>
            </div>
          </div>
          <div className="match_history--6">
            {participantIdentities &&
              participantIdentities.map(gamer => {
                return (
                  <div key={gamer.participantId} className="player">
                    {participants.map(player => {
                      if (
                        player.participantId === gamer.participantId
                      ) {
                        return (
                          <div
                            key={player.participantId}
                            style={{
                              backgroundImage: `url("http://ddragon.leagueoflegends.com/cdn/11.2.1/img/champion/${getChampion(
                                player.championId
                              )}.png")`,
                            }}
                            className="player__img player__img--1"></div>
                        );
                      }
                    })}
                    <span className="player__name">
                      {gamer.player.summonerName}
                    </span>
                  </div>
                );
              })}
          </div>
          {/* win_true 
            match_history--7
          */}
          <div
            className={`match_history--7 ${
              participantObj.stats.win ? "win_true" : "win_false"
            }`}>
            <span>&#8744;</span>
          </div>
        </div>
      )}
    </>
  );
}
